(function () {
    'use strict';

    angular.module("imApp").factory("stockZoneService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 931,
                    parameters: parms || {}
                });
            },
            listStockZoneClasses: function (parms) {
                return $ihttp.post({
                    method: 1028,
                    parameters: parms || {}
                });
            },
            listWareHouses: function (parms) {
                return $ihttp.post({
                    method: 2542,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 932,
                    parameters: edit
                });
            },
            deleteItem: function (edit) {
                return $ihttp.post({
                    method: 933,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
